import React from 'react';

const Footer = () => {
    return(
        <div className='footer'>
            <a href='https://leszekk.eu'>
                <img src='https://www.leszekk.eu/img/fav/mstile-150x150.png' alt='leszekkeu-logo' className='footerLogo'/>
                <h2>&copy; Leszekk.eu</h2>
                <h2 className='separator'>|</h2>
                <h2>Created by Leszek Korzan</h2>
            </a>

        </div>
    )
}
export default Footer;